import request from '@/config/axios'

export interface AreaAgentTerritoryRateVO {
  id?: number
  agentType: number
  areaId: number
  areaName?: string
  bonusRate: number
  status: number
  createTime?: string
}

export interface AreaAgentTerritoryRatePageReq {
  pageNo?: number
  pageSize?: number
  agentType?: number
  areaId?: number
  status?: number
}

export const getAreaAgentTerritoryRatePage = async (params: AreaAgentTerritoryRatePageReq) => {
  return await request.get({ url: '/trade/area-agent/territory-rate/page', params })
}

export const getAreaAgentTerritoryRate = async (id: number) => {
  return await request.get<AreaAgentTerritoryRateVO>({
    url: '/trade/area-agent/territory-rate/get',
    params: { id }
  })
}

export const createAreaAgentTerritoryRate = async (data: AreaAgentTerritoryRateVO) => {
  return await request.post({ url: '/trade/area-agent/territory-rate/create', data })
}

export const updateAreaAgentTerritoryRate = async (data: AreaAgentTerritoryRateVO) => {
  return await request.put({ url: '/trade/area-agent/territory-rate/update', data })
}

export const deleteAreaAgentTerritoryRate = async (id: number) => {
  return await request.delete({ url: '/trade/area-agent/territory-rate/delete', params: { id } })
}
